import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getDirectLoggedIn, RedirectService } from '@uxdf/direct-shared-lib';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private readonly store: Store<any>,
    private readonly router: Router,
    private readonly redirectService: RedirectService
  ) {}

  canActivate(_, routerState: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.redirectService.redirect = routerState.url;

    return this.store.pipe(
      select(getDirectLoggedIn),
      take(1),
      map(loggedIn => {
        if (loggedIn) {
          return true;
        }
        console.warn('[AUTH GUARD]');
        return this.router.createUrlTree(['login']);
      })
    );
  }
}
